import {greenColor, oceanBlueColor, DodgerBlueColor} from '../../cmsMainStyle'

const enhancedTableStyle = theme => ({
	root: {
		// width: '100%',
	},

	paper: {
		marginBottom: theme.spacing(2),
	},

	table: {
		minWidth: 300,
	},

	container: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 250)
	},

	toolbar: {
		display: 'flex',
		alignItems: 'center',
	},

	tablePagination: {
		padding: 10
	},

	linkContent: {
		color: "blue",
		cursor: "pointer"
	},

	unlinkContent: {
		color: "black",
		// cursor: "pointer"
	},

	confidentialIcon: {
		color: greenColor[12]
	},

	openDetailIcon: {
		color: oceanBlueColor[8],
		cursor: "pointer"
	},

	hintIcon: {
		display: "inline-block"
	}

})

export default enhancedTableStyle